import React, { useEffect, useState } from "react";
import { getselectedIds, MakeAxiosRequest } from "../../../utils/handler";
import ModalBox from "../../../Components/modals/ModalBox";
import { SwalError, SwalSuccess } from "../../../Components/SwalFns";
import { FormProvider, useForm } from "react-hook-form";
import FormFields from "../../../Components/inputs/FormFields";

function EditAccountPermission({ userKey, showModal, closeModal }) {
  const methods = useForm();
  const { handleSubmit, reset, setValue, watch, trigger, getValues } = methods;

  const [response, setResponse] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      console.log(userKey);
      const res = await MakeAxiosRequest("post", "editrelationpermission", {
        user_proxy_permission_key: userKey,
      });
      if (res.name !== "CanceledError" && res.status == 1) {
        res.data.paymentSelectionOptions = res.data.paymentSelection?.map((item) => ({
          id: item.value,
          text: item.text,
          is_selected: item.is_selected,
        }));
        setResponse(res.data);
        // console.log(res.data);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    userKey && fetchData();
  }, [userKey]);
  
  useEffect(() => {
    reset({
      wallet_access: getselectedIds(response.paymentSelectionOptions,'is_selected',1)?.[0],
    });
  }, [response]);
  
  const updateAccess = async (data) => {
    try {
      const response = await MakeAxiosRequest(
        "post",
        "updateaccountpermission",
        { ...data, user_proxy_permission_key: userKey }
      );
      if (response.status == 1) {
        reset();
        closeModal();
        SwalSuccess({ msg: response.message});
      } else if (response.status == 0) {
        SwalError({ msg: response.message });
      } else {
        // setError('phone_number', { type: 'custom', message: response.message });
        console.log(response.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const fields = [
    {
      name: "wallet_access",
      className: "col-12 mb-3",
      rules: { required: "Please select" },
      type: "radio",
      options: response.paymentSelectionOptions,
      optionsClassName: "col-12",
      isShow: response.paymentSelectionOptions?.length > 0,
    },
  ];

  return (
    <ModalBox
      isShow={showModal}
      handleClose={closeModal}
      modalSize="md"
      hasData={!isLoading}
      hideClose={true}
    >
      <div className="text-center position-relative">
        <h3 className="modal-title mb-0">Edit Account Access</h3>
      </div>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(updateAccess)}>
          <div>
            <div className="d-flex align-items-center justify-content-center flex-wrap text-center">
              <div>
                <div className="profile-img">
                  <img
                    src={response.proxydata?.image_path}
                    // style={{ width: "35px", height: "35px" }}
                  />
                </div>
                <div className=" text-lg-start rltnshp-txt w-100">
                  <p className="mb-0 text-center" style={{fontSize: '20px', fontWeight: '700', margin: '0px !important'}}>{response.proxydata?.name}</p>
                  {response.proxydata?.proxy_relation && (
                    <small className="d-block text-center">
                      {response.proxydata?.proxy_relation}
                    </small>
                  )}
                </div>
              </div>
            </div>
            <FormFields fields={fields} />
          </div>
          <div className="row">
            <div className="col-lg-6">
              {/* {response.buttondetails?.show_button_title1 === 1 && ( */}
              <button
                type="button"
                className="btn btn-primary rounded-pill w-100 my-2 p-2"
                onClick={closeModal}
              >
                Cancel
              </button>
              {/* )} */}
            </div>
            <div className="col-lg-6">
              <button
                type="submit"
                className="btn btn-primary rounded-pill w-100 my-2 p-2"
              >
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </FormProvider>
    </ModalBox>
  );
}

export default EditAccountPermission;
